module.exports = __webpack_public_path__ + "images/application/illustrations/banner-ac-bg-6d628111.svg";